import React, { useEffect, useState } from "react";
import {
  getActivityLogsReportApi,
  exportActivityLogsExcelApi
} from "../../services/activityLogApi";

const ActivityLogsPage = () => {

  const [logs, setLogs] = useState([]);

  // ===============================
  // ONLY DATE FILTERS (BACKEND DRIVEN)
  // ===============================
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: ""
  });

  // ===============================
  // FORMAT DATE FOR POSTGRES (IMPORTANT)
  // ===============================
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0]; // YYYY-MM-DD
  };

  // ===============================
  // FETCH LOGS
  // ===============================
  const fetchLogs = async (customFilters = filters) => {
    try {

      const cleanedFilters = {
        start_date: formatDate(customFilters.start_date),
        end_date: formatDate(customFilters.end_date)
      };

      const res = await getActivityLogsReportApi(cleanedFilters);

      setLogs(res.data);

    } catch (err) {
      console.log("Error fetching logs:", err);
    }
  };

  // ===============================
  // INITIAL LOAD
  // ===============================
  useEffect(() => {
    fetchLogs(filters);
  }, []);

  // ===============================
  // HANDLE INPUT
  // ===============================
  const handleChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div style={{ padding: "20px" }}>

      <h2>📊 Admin Activity Monitoring</h2>

      <p style={{ color: "#666" }}>
        View all system activity logs (staff + admin actions)
      </p>

      {/* ================= FILTERS ================= */}
      <div style={{ marginBottom: "15px", display: "flex", gap: "10px", flexWrap: "wrap" }}>

        {/* DATE RANGE ONLY */}
        <input
          type="date"
          name="start_date"
          onChange={handleChange}
        />

        <input
          type="date"
          name="end_date"
          onChange={handleChange}
        />

        {/* ACTION BUTTONS */}
        <button onClick={() => fetchLogs(filters)}>
          🔍 Search
        </button>

        <button onClick={() => exportActivityLogsExcelApi(filters)}>
          📥 Export Excel
        </button>

      </div>

      {/* ================= TABLE ================= */}
      <div style={{ overflowX: "auto" }}>

        <table border="1" width="100%" cellPadding="8">

          <thead style={{ background: "#f5f5f5" }}>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Action</th>
              <th>Module</th>
              <th>Sub Module</th>
              <th>Description</th>
              <th>Entity</th>
              <th>IP</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  No logs found
                </td>
              </tr>
            ) : (
              logs.map((log, i) => (
                <tr key={i}>

                  <td>{log.user_name || "-"}</td>
                  <td>{log.user_email || "-"}</td>

                  <td>
                    <span style={{
                      padding: "3px 8px",
                      borderRadius: "5px",
                      background:
                        log.action === "CREATE"
                          ? "#d4edda"
                          : log.action === "UPDATE"
                          ? "#fff3cd"
                          : log.action === "DELETE"
                          ? "#f8d7da"
                          : "#e2e3e5"
                    }}>
                      {log.action}
                    </span>
                  </td>

                  <td>{log.module || "-"}</td>
                  <td>{log.sub_module || "-"}</td>
                  <td>{log.description || "-"}</td>

                  <td>
                    {log.entity_type || "-"} ({log.entity_id || "-"})
                  </td>

                  <td>{log.ip_address || "-"}</td>

                  <td>
                    {new Date(log.created_at).toLocaleString()}
                  </td>

                </tr>
              ))
            )}
          </tbody>

        </table>

      </div>

    </div>
  );
};

export default ActivityLogsPage;